export default __webpack_public_path__ + "static/media/popular-place-venice.738db38f.jpg";